export interface FiltroElenco {
  readonly chiave: string
  readonly etichetta: string
  readonly su: 'impianto' | 'dichiarazione'
  readonly valore: string
  /** Stato raggiungibile solo col prelievo dai distributori (SP5) o l'import massivo. */
  readonly attivoDaSP5?: boolean
}

export const FILTRI_ELENCO: readonly FiltroElenco[] = [
  { chiave: 'attivi', etichetta: 'Tutti gli impianti Attivi', su: 'impianto', valore: 'attivo' },
  { chiave: 'letture_non_inserite', etichetta: 'Letture non inserite', su: 'dichiarazione', valore: 'letture_non_inserite' },
  { chiave: 'bozza', etichetta: 'Bozza', su: 'dichiarazione', valore: 'bozza' },
  { chiave: 'letture_da_controllare', etichetta: 'Letture da controllare', su: 'dichiarazione', valore: 'letture_da_controllare', attivoDaSP5: true },
  { chiave: 'da_firmare', etichetta: 'Da firmare', su: 'dichiarazione', valore: 'da_firmare' },
  { chiave: 'da_inviare', etichetta: 'Da Inviare', su: 'dichiarazione', valore: 'da_inviare' },
  { chiave: 'inviate', etichetta: 'Inviate', su: 'dichiarazione', valore: 'inviata' },
  { chiave: 'inattivi', etichetta: 'Inattivi', su: 'impianto', valore: 'inattivo' },
  { chiave: 'sospesi', etichetta: 'Sospesi', su: 'impianto', valore: 'sospeso' },
  { chiave: 'archiviati', etichetta: 'Archiviati', su: 'impianto', valore: 'archiviato' },
]

export function condizioneFiltro(chiave: string): { campo: string; valore: string } {
  const f = FILTRI_ELENCO.find((x) => x.chiave === chiave)
  if (!f) throw new Error(`filtro sconosciuto: ${chiave}`)
  return { campo: f.su === 'impianto' ? 'stato' : 'statoUltimaDichiarazione', valore: f.valore }
}
